import { Stack, styled, Tab, Tabs } from "@mui/material";
import { addDays, format, parseISO } from "date-fns";
import { useState } from "react";
import { HomepageSparklineDay } from "../../../graphql/types";
import { StatusCalendar } from "./StatusCalendar";

const Container = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.surfaceLight30.main}`,
  boxShadow: theme.mixins.shadowSurfaceLight10,
  ...theme.applyStyles("dark", {
    boxShadow: theme.mixins.shadowSurfaceDark10,
  }),
  padding: "16px 28px",
  gap: "16px",
  borderRadius: "8px",
  height: "380px",
  width: "380px",
  backgroundColor: theme.palette.surfaceLight10.main,
}));

const CalendarWithMonths = ({
  onClickDay,
  selectedDay,
  selectedMonth,
  sparkline,
  sparklineFirstDate,
  leftMonth,
  rightMonth,
  year,
}: {
  onClickDay: (day: number, month: number) => void;
  selectedDay: number;
  selectedMonth?: number;
  sparkline: HomepageSparklineDay[];
  sparklineFirstDate: string;
  leftMonth: number;
  rightMonth: number;
  year: number;
}) => {
  const [selectedTab, setSelectedTab] = useState(rightMonth);

  // given the sparklineFirstDate compute all the sparkline data for the current month and the previous month
  const sparklineFromRightMonth: HomepageSparklineDay[] = [];
  const sparklineFromLeftMonth: HomepageSparklineDay[] = [];
  sparkline.forEach((date, index) => {
    const currentDate = addDays(parseISO(sparklineFirstDate), index);
    if (currentDate.getMonth() === leftMonth) {
      sparklineFromLeftMonth.push(date);
    } else {
      sparklineFromRightMonth.push(date);
    }
  });
  return (
    <Container>
      <Tabs
        value={selectedTab}
        onChange={(event, newValue) => {
          setSelectedTab(newValue);
        }}
        centered
      >
        <Tab
          sx={{
            width: "48%",
          }}
          value={leftMonth}
          label={format(new Date(0, leftMonth), "MMMM")}
          data-testid="previous-month-tab"
        />
        <Tab
          sx={{
            width: "48%",
          }}
          value={rightMonth}
          label={format(new Date(0, rightMonth), "MMMM")}
          data-testid="current-month-tab"
        />
      </Tabs>
      {selectedTab == rightMonth ? (
        <StatusCalendar
          selectedDay={selectedMonth === rightMonth ? selectedDay : undefined}
          onClickDay={onClickDay}
          monthNumber={rightMonth}
          sparkline={sparklineFromRightMonth}
          year={year}
        />
      ) : (
        <StatusCalendar
          selectedDay={selectedMonth === leftMonth ? selectedDay : undefined}
          monthNumber={leftMonth}
          onClickDay={onClickDay}
          sparkline={sparklineFromLeftMonth}
          year={year}
        />
      )}
    </Container>
  );
};

export { CalendarWithMonths };
